import React, { useState } from "react";

const MessageRow = ({ speaker, text, metadata, isLast }) => {
    const [isSourcesOpen, setIsSourcesOpen] = useState(false);

    const toggleSources = () => setIsSourcesOpen(!isSourcesOpen);

    return (
        <div className={`message-row ${speaker}`}>
            <div className="message-content">{text}</div>

            {speaker === "assistant" && (
                <div className="metadata">
                    {metadata?.sources?.length > 0 && (
                        <div className="sources">
                            <button onClick={toggleSources} className="toggle-sources">
                                {isSourcesOpen ? "Hide sources" : "Show sources"}
                            </button>
                            {isSourcesOpen && (
                                <ul className="source-list">
                                    {metadata.sources.map((source, index) => (
                                        <li key={index}>
                                            {source.citation && <p className="citation">{source.citation}</p>}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MessageRow;
